import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhLocationListItem extends SearchModelBase {
    location: string = '';
    zone: string = '';
    row: string = '';
    level: string = '';
    storage: boolean|null = null;
    id: number = 0;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u1ID: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Location', width: 150, dataIndex: 'location', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Zone', width: 80, dataIndex: 'zone'}),
        XCol.Create({ col: 3, text: 'Row', width: 80, dataIndex: 'row'}),
        XCol.Create({ col: 4, text: 'Level', width: 80, dataIndex: 'level'}),
        XCol.Create({ col: 5, text: 'Occupied', width: 80, dataIndex: 'storage', type: XCol.XCellType.Bool, noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 7, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 8, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 9, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return WhLocationListItem.ExportCollection
    };
	
    public static OrderBy = { orderBy: WhLocationListItem.prototype.location, orderByAscending: false };

    public static formatData(data: WhLocationListItem[]) {
        return data.map((d: WhLocationListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
